import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { Contacts } from "../contacts"
import ListsListing from "./containers/listing"
import { ListsContext } from "./context"
import "./styles.scss"
import { TLists } from "./types"

export function Lists({ }: TLists) {
    return <ContentSectionContainer className="listsContainer">
        <ListsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.lists })} element={<ListsListing />} />
                <Route index path={fetchRoute({ route: ERoutes.listContacts })} element={<Contacts subRoute={true} />} />

                <Route index path={"/"} element={<ListsListing />} />
                <Route index path={"/:listId/contacts"} element={<Contacts subRoute={true} />} />

            </Routes>
        </ListsContext.Provider>
    </ContentSectionContainer>
}